function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M273.777.62h17.079l36.208 52.701L362.556.619H379.6v116.437h-16.806V30.35L327.203 83.2 290.583 29.9v87.156h-16.806z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M171.162 50.086h48.247v17.507h-48.247V99.17h61.926v17.506h-79.432V1.77h79.432v17.506h-61.926zM58.86 100c-22.342 0-40.479-18.257-40.479-40.81 0-22.551 18.137-40.809 40.48-40.809 12.29 0 23.665 5.545 31.318 14.952l14.259-11.6C93.335 8.085 76.748 0 58.861 0 26.339 0 0 26.514 0 59.19c0 32.677 26.34 59.191 58.86 59.191 32.522 0 58.861-26.514 58.861-59.19V50h-58.86v18.381H98.31C94.173 86.501 78.072 100 58.86 100z"
})));

function SvgGem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 119,
    viewBox: "0 0 380 119",
    width: 380
  }, props), _ref);
}

export default SvgGem;